"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _get = _interopRequireDefault(require("lodash/get"));

var _isString = _interopRequireDefault(require("lodash/isString"));

var _size = _interopRequireDefault(require("lodash/size"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _beNovativeKit = _interopRequireDefault(require("@bit/be-novative.kit.spinner"));

var _beNovativeKit2 = _interopRequireDefault(require("@bit/be-novative.kit.overflow-counter"));

var _beNovativeKit3 = _interopRequireDefault(require("@bit/be-novative.kit.form-feedback"));

var _beNovativeKit4 = require("@bit/be-novative.kit.richtext-utils");

var _formControlModule = _interopRequireDefault(require("./formControl.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var HORIZONTAL = 'horizontal';
var VERTICAL = 'vertical';

var formControlFactory = function formControlFactory(WrappedComponent) {
  var FormControl = /*#__PURE__*/function (_Component) {
    _inherits(FormControl, _Component);

    var _super = _createSuper(FormControl);

    function FormControl() {
      _classCallCheck(this, FormControl);

      return _super.apply(this, arguments);
    }

    _createClass(FormControl, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            action = _this$props.action,
            disabled = _this$props.disabled,
            input = _this$props.input,
            isLoading = _this$props.isLoading,
            label = _this$props.label,
            layout = _this$props.layout,
            maxLength = _this$props.maxLength,
            _this$props$meta = _this$props.meta,
            meta = _this$props$meta === void 0 ? {} : _this$props$meta,
            secondaryLabel = _this$props.secondaryLabel,
            required = _this$props.required,
            hint = _this$props.hint,
            shake = _this$props.shake,
            fieldWrapperClass = _this$props.fieldWrapperClass,
            inputWrapperClass = _this$props.inputWrapperClass,
            showCharCounter = _this$props.showCharCounter,
            rest = _objectWithoutProperties(_this$props, ["action", "disabled", "input", "isLoading", "label", "layout", "maxLength", "meta", "secondaryLabel", "required", "hint", "shake", "fieldWrapperClass", "inputWrapperClass", "showCharCounter"]);

        var validating = meta.validating,
            warning = meta.warning,
            submitFailed = meta.submitFailed;
        var showLabel = (0, _size.default)(label) > 0;
        var validationMessage = this.renderMessage();
        var intent = warning ? 'warning' : 'danger';
        var inputName = (0, _get.default)(input, 'name');
        var inputValue = (0, _get.default)(input, 'value');
        var isStringValue = (0, _beNovativeKit4.isEditorState)(inputValue) || (0, _isString.default)(inputValue);

        var inputProps = _objectSpread({}, input, {
          id: inputName,
          disabled: disabled,
          maxLength: maxLength,
          required: required
        });

        var isHorizontal = layout === HORIZONTAL;
        var showSpinner = validating || isLoading;

        var Hint = /*#__PURE__*/_react.default.createElement("p", {
          className: _formControlModule.default.Hint,
          "data-test": "hint"
        }, hint);

        var classes = (0, _classnames.default)(_formControlModule.default.Wrapper, _formControlModule.default[layout], fieldWrapperClass, _defineProperty({}, _formControlModule.default.shake, submitFailed && shake));
        return /*#__PURE__*/_react.default.createElement("div", {
          className: classes
        }, /*#__PURE__*/_react.default.createElement("header", {
          className: _formControlModule.default.LabelWrapper
        }, showLabel && /*#__PURE__*/_react.default.createElement("label", {
          htmlFor: inputName,
          className: _formControlModule.default.Label
        }, required && !isHorizontal && /*#__PURE__*/_react.default.createElement("span", {
          className: _formControlModule.default.asterisk
        }, "* "), /*#__PURE__*/_react.default.createElement("strong", null, label), required && isHorizontal && /*#__PURE__*/_react.default.createElement("span", {
          className: _formControlModule.default.asterisk
        }, " *"), secondaryLabel && /*#__PURE__*/_react.default.createElement("span", {
          className: _formControlModule.default.Secondary,
          "data-test": "secondary"
        }, ' ', secondaryLabel), showSpinner && /*#__PURE__*/_react.default.createElement(_beNovativeKit.default, {
          type: "bubble",
          className: _formControlModule.default.Spinner
        })), hint && !isHorizontal && Hint), /*#__PURE__*/_react.default.createElement("main", {
          className: (0, _classnames.default)(_formControlModule.default.FieldWrapper, inputWrapperClass)
        }, /*#__PURE__*/_react.default.createElement(WrappedComponent, _extends({
          input: inputProps,
          meta: meta,
          maxLength: maxLength
        }, rest)), hint && isHorizontal && Hint, /*#__PURE__*/_react.default.createElement("footer", {
          className: _formControlModule.default.Message
        }, /*#__PURE__*/_react.default.createElement("span", {
          "data-test": "validation"
        }, validationMessage && /*#__PURE__*/_react.default.createElement(_beNovativeKit3.default, {
          intent: intent
        }, validationMessage)), /*#__PURE__*/_react.default.createElement("span", null, showCharCounter && maxLength && isStringValue && /*#__PURE__*/_react.default.createElement(_beNovativeKit2.default, {
          maxLength: maxLength,
          value: inputValue
        })))));
      }
    }, {
      key: "renderMessage",
      value: function renderMessage() {
        var _this$props2 = this.props,
            meta = _this$props2.meta,
            validateOnSubmit = _this$props2.validateOnSubmit;
        var error = meta.error,
            warning = meta.warning,
            invalid = meta.invalid,
            touched = meta.touched,
            submitFailed = meta.submitFailed;
        var showValidationMessage = !validateOnSubmit && touched && invalid || validateOnSubmit && submitFailed;
        var message = error || warning;

        if ((0, _isString.default)(message) && showValidationMessage) {
          return message;
        } else {
          return null;
        }
      }
    }]);

    return FormControl;
  }(_react.Component);

  _defineProperty(FormControl, "propTypes", {
    disabled: _propTypes.default.bool,
    layout: _propTypes.default.oneOf([HORIZONTAL, VERTICAL]),
    meta: _propTypes.default.object,
    showCharCounter: _propTypes.default.bool
  });

  _defineProperty(FormControl, "defaultProps", {
    layout: 'vertical',
    meta: {},
    showCharCounter: true,
    validateOnSubmit: true
  });

  return FormControl;
};

var _default = formControlFactory;
exports.default = _default;

//# sourceMappingURL=formControl.js.map